import { atom } from 'jotai';
import { actionsAtom } from '../karratco/submit/proposal/proposalForm';
import { ContractMethod, MethodInput, Action } from '@/app/types/proposals';

export const titleAtom = atom<string>('');
export const descriptionAtom = atom<string>('');
export const selectedMethodsAtom = atom<Action[]>([]);
export const contractMethodsAtom = atom<ContractMethod[]>([]);
export const methodInputsAtom = atom<MethodInput[]>([]);
export const isPublishingAtom = atom<boolean>(false);
export const txHashAtom = atom<string | null>(null);

export const selectedProposalTypeAtom = atom(
  (get) => {
    const selectedProposalType = get(_selectedProposalTypeAtom);
    return selectedProposalType;
  },
  (_, set, newValue: string) => {
    set(_selectedProposalTypeAtom, newValue);
    set(actionsAtom, []);
  },
);

const _selectedProposalTypeAtom = atom<string>('');
